export const formatString = (input: string | undefined | null): string => {
  if (!input) return ''
  return input.toLowerCase().replace(/[^a-z0-9]/g, '')
}
